import React from 'react';
import theme from './style/theme';

const UnderMaintenance = () => {
    // Fruitbox orange color
    const fruitboxOrange = '#FF6B00';
    
    const styles = {
      container: {
        display: 'flex',
        flexDirection: 'column' as 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        textAlign: 'center' as 'center',
        padding: '20px',
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary,
      },
      heading: {
        marginBottom: '20px',
        fontSize: '2.5rem',
        color: fruitboxOrange, // Using the Fruitbox orange color
      },
      message: {
        marginBottom: '30px',
        fontSize: '1.2rem',
        maxWidth: '600px',
      }
    };
  
    return (
      <div style={styles.container}>
        <h1 style={styles.heading}>🛠️ Huoltokatko 🛠️</h1>
        <p style={styles.message}>
          Suoritamme parhaillaan sivuston suunniteltua huoltoa.
          Palaamme verkkoon pian. Kiitos kärsivällisyydestäsi.
        </p>
      </div>
    );
};

export default UnderMaintenance;